import { Notify } from 'notiflix';
import React, { useEffect, useRef, useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import Loader from '../components/loader/Loader';
import { validateRoute } from '../data/api/users/UserRoutes';
import useIndex from '../hooks/useIndex';
import UnauthorizedPage from '../pages/error/UnauthorizedPage';

// Cache en memoria de rutas ya validadas durante la sesión actual del SPA.
// Vive solo lo que dura la pestaña — al recargar se reinicia. Evita pegarle
// al backend en cada navegación y choca con el rate limiter.
const validatedPaths = new Set();

const ProtectedRoute = () => {

    const { token } = useIndex();
    const currentLocation = useLocation();
    const [loading, setLoading] = useState(true);
    const [validPage, setValidPage] = useState();
    const lastChecked = useRef(null);

    useEffect(() => {
        const path = currentLocation?.pathname;
        if (!path || lastChecked.current === path) return;
        lastChecked.current = path;

        if (validatedPaths.has(path)) {
            setValidPage(true);
            setLoading(false);
            return;
        }
        loadData(path);
    }, [currentLocation]);

    const loadData = async (path) => {
        setLoading(true);
        try {
            const { data } = await validateRoute(token, { path });
            const ok = !!data?.success;
            setValidPage(ok);
            if (ok) validatedPaths.add(path);
        } catch (error) {
            const errorResponse = error?.response?.data?.message;
            setValidPage(false);
            if (errorResponse) Notify.failure(errorResponse);
        } finally {
            setLoading(false);
        }
    }

    if (loading) {
        return (<Loader />)
    } else {
        if (validPage) {
            return <Outlet />
        } else {
            return <UnauthorizedPage />
        }
    }
}

export default ProtectedRoute
